





























import { Component, Vue} from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class AccountImport extends Vue {

    fileData: any = null;
    // 下载模板
    startDownload: boolean = false;


    get templateUrl() {
        return "http://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/%E7%A8%8E%E5%8A%A1%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xlsx"
    }

    downloadExcel() {
        this.startDownload = true;
    }
    changeFile(e: any) {
        if (e.target.files[0]) {
            let file = e.target.files[0];
            let data = new FormData();
            data.append("file", file);
            e.target.value = null;
            this.fileData = data;
        }
    }

    confirm() {
        Vue.axios
            .post(`system/upload/tax/info`, this.fileData)
            .then(res => {
                this.fileData = null;
                this.$message.success(res.data.message);
                this.$emit("finish");
            }).catch(res => {
                this.$message.warning(res.data.message);
            });
    }
    closeDialog() {
        this.$emit("close");
    }

}
